import { KeyRound, Phone, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_RAW, ADDRESS } from "../../data/content";

export const Footer = ({ onNav }) => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-brand-anthracite border-t-4 border-brand-orange"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <button
              onClick={() => onNav("hero")}
              className="flex items-center gap-2.5 group"
            >
              <span className="grid place-items-center h-9 w-9 rounded-lg bg-brand-orange text-white">
                <KeyRound className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <span className="font-heading font-extrabold text-white text-lg tracking-tight">
                Klíče<span className="text-brand-orange">Ostrava</span>
              </span>
            </button>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Výroba klíčů a autoklíčů v Ostravě. Klíče, autoklíče, zámky
              i nouzová pomoc na jednom místě.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Kontakt</h4>
            <a
              href={PHONE_RAW}
              data-testid="footer-phone"
              className="flex items-center gap-2.5 text-sm text-slate-300 hover:text-brand-orange transition-colors"
            >
              <Phone className="h-4 w-4 text-brand-orange" />
              {PHONE_DISPLAY}
            </a>
            <p className="mt-3 flex items-start gap-2.5 text-sm text-slate-300">
              <MapPin className="h-4 w-4 text-brand-orange mt-0.5 shrink-0" />
              {ADDRESS}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">Rychlé odkazy</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: "Služby", id: "sluzby" },
                { label: "Autoklíče", id: "autoklice" },
                { label: "Recenze", id: "recenze" },
                { label: "Kontakt", id: "kontakt" },
              ].map((l) => (
                <button
                  key={l.id}
                  onClick={() => onNav(l.id)}
                  className="text-left text-sm text-slate-300 hover:text-brand-orange transition-colors w-fit"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} klice-ostrava.cz — Výroba klíčů a
            autoklíčů v Ostravě.
          </p>
          <p className="text-xs text-slate-500">
            Rychle • Spolehlivě • Ostrava
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
